import { render, staticRenderFns } from "./TabHobby.vue?vue&type=template&id=36978411&scoped=true&"
import script from "./TabHobby.vue?vue&type=script&lang=js&"
export * from "./TabHobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36978411",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36978411')) {
      api.createRecord('36978411', component.options)
    } else {
      api.reload('36978411', component.options)
    }
    module.hot.accept("./TabHobby.vue?vue&type=template&id=36978411&scoped=true&", function () {
      api.rerender('36978411', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabHobby.vue"
export default component.exports